export const colors = {
  primary: "#F74902",
  backgroundSecondary: "#121212",
  darkGray: "#1E1E1E"
};
